import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import VariantButton from '../components/variant-button';
import Section from '../components/section';

const Wrapper = styled.div`
  ${VariantButton} {
    margin-bottom: .75rem;
    width: 100%;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      width: auto;
      margin-bottom: 0;
      margin-right: .75rem;
    }
  }
`;

const Buttons = ({ rowOptions, items = [], className }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Section
      id={rowOptions?.sectionId || ''}
      backgroundColor={rowOptions?.backgroundColor}
      hideBottomSpacing={rowOptions?.hideBottomSpacing}
      hideTopSpacing={rowOptions?.hideTopSpacing}
      hideRow={rowOptions?.hideRow}
      className={className}
    >
      <Container small>
        <Wrapper>
          {items.map((item) => (
            <VariantButton
              variant={item.variant}
              key={item.id}
              to={item.link}
            >
              {item.text}
            </VariantButton>
          ))}
        </Wrapper>
      </Container>
    </Section>
  );
};

export default styled(Buttons)``;
